module.exports = __webpack_public_path__ + "index-banner-m-new.jpg?84a70d879289fafbd9efc39376d2167f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner-m-new.jpg
// module id = 90
// module chunks = 0